import { lazy } from "react";
const Main = lazy(() => import("../pages/Main.view"));
export const generalRouter = {
  home: "/",
  login: "/login",
  register: "/register",
};
export default {
  General: [
    {
      path: generalRouter.home,
      component: Main,
    },
  ],
};
